import { ModalContainer, SectionHeader, SwitchAppButton } from "..";
import { IQuickSubmitFormViewProps } from "./QuickSubmitForm";

export const View = (props: IQuickSubmitFormViewProps) => {
  return (
    <ModalContainer
      isModalOpen={props.isModalOpen}
      closeModal={props.closeModal}
      selectorPrimaryFocus="button.switchapp-themed"
      modalHeader={<SectionHeader title={props.formTitle || "Delete item"} />}
    >
      <div className="quick-submit-form--container">
        {props.isDeleteLocked
          ? props.deleteLockedInfo ||
            "This item cannot be deleted because it has been used and is now bound to another item."
          : props.confirmationMessage ||
            "Are you sure you want to delete this item?"}
      </div>

      <div className="flex-container justify-content--end align-items--end btn-container">
        <SwitchAppButton
          size="sm"
          kind={props.buttonKind || "danger"}
          className="mt-5 ml-5 mr-5 pl-5 pr-5"
          isLoading={props.isSubmitting}
          disabled={props.isDeleteLocked}
          onClick={() => props.onButtonClick()} // NOTE: necessary to ignore post-data BUG from POST & PUT methods in useQuickSubmitFormHelper()
        >
          {props.buttonText || "Delete Item"}
        </SwitchAppButton>
      </div>
    </ModalContainer>
  );
};
